import {FormControl, FormControlLabel, Grid, Radio, RadioGroup, SelectChangeEvent, Stack} from '@mui/material';
import {FC} from 'react';
import {useStore} from 'zustand';
import {useStoresContext} from '../../hooks/useStoresContext';
import {buttonStyles as STYLES} from './DashboardControlButtons.styles';
import {DashboardTypes} from '../../../../../../shared/types/dashboard.types';

interface Props {
  serviceType: string;
  hideChartTypeControls?: boolean;
}

export const DashboardControlButtons: FC<Props> = ({serviceType, hideChartTypeControls = true}) => {
  const {chartViewStore, dashboardTypeStore} = useStoresContext(serviceType);
  const {type, setType} = useStore(chartViewStore);
  const {dashboardType, setDashboardType} = useStore(dashboardTypeStore);

  const handleTypeChange = (_: SelectChangeEvent, value: string) => {
    setType(value);
  };

  const handleDashboardTypeChange = (_: SelectChangeEvent, value: string) => {
    setDashboardType(value as DashboardTypes);
  };

  return (
    <Stack flexDirection="column" gap={1} paddingTop={1} paddingBottom={1}>
      <Grid container columnSpacing={0} rowSpacing={0} sx={{width: 'fit-content'}}>
        <Grid item xs={12} sx={{width: 'fit-content'}}>
          <FormControl sx={{width: '100%'}}>
            <RadioGroup
              defaultValue={DashboardTypes.REQUESTS_MOVE}
              name="dashboardType"
              row
              value={dashboardType}
              onChange={handleDashboardTypeChange}
            >
              <Grid container>
                <Grid item xs={6}>
                  <FormControlLabel
                    value={DashboardTypes.REQUESTS_MOVE}
                    control={<Radio />}
                    label="Движение&nbsp;заявок"
                    sx={STYLES.chartRadio}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    value={DashboardTypes.REQUESTS_STATUSES}
                    control={<Radio />}
                    label="Статус заявок"
                    sx={STYLES.chartRadio}
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>
        {!hideChartTypeControls && (
          <Grid item xs={12}>
            <FormControl sx={{width: '100%'}}>
              <RadioGroup defaultValue="common" name="type" row value={type} onChange={handleTypeChange}>
                <Grid container>
                  <Grid item xs={6}>
                    <FormControlLabel value="common" control={<Radio />} label="Диаграмма" sx={STYLES.chartRadio} />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel
                      value="part"
                      control={<Radio />}
                      label="Показать&nbsp;значение"
                      sx={STYLES.chartRadio}
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
            </FormControl>
          </Grid>
        )}
      </Grid>
    </Stack>
  );
};
